import { gql } from "graphql-request";
export const LAST_ARTICLES_PER_BLOG = gql`
    query lastArticlesPerBlog($domainId: Int) {
        allPosts(
            limit: 4
            offset: 0
            published: true
            isDeleted: false
            typeId: 2295
            orderByDesc: createdAt
            domainId: $domainId
        ) {
            id
            domainId
            categoryId
            title
            excerpt
            body
            translations {
                key
                value
                language
            }
            image {
                fullPath
                path
            }
            url {
                id
                modelId
                title
                language
                isActive
                url
            }
        }
    }
`;
